import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../updateAction';
import { validate_ci } from 'ci_node';
import cn from 'classnames';
import { Dialog } from '@reach/dialog';

import BackButton from '../components/BackButton';
import Button from '../components/Button';
import Input from '../components/Input';
import Label from '../components/Label';
import ModalCedula from '../components/ModalCedula';
import RadioGroup from '../components/RadioGroup';
import StackForm from '../components/StackForm';
import Title from '../components/Title';
import { click_next_step2 } from '../techspec';

import { residencias, cedulas } from '../data';

import useStore from '../store';

const getMaskedNumber = n => {
  // console.log('getMaskedNumber');
  let numero;

  n = n?.replace(/\./g, '').replace(/\-/g, '');

  if (n) {
    numero = parseInt(n, 10);
    numero = numero.toString();
    // console.log({ n, numero });
  } else {
    numero = n;
  }

  const length = numero?.length;

  if (length) {
    const numeros = Array.from(numero);
    let nuevos = numeros;

    if (length > 7) {
      const part3 = numeros.slice(length - 1);
      const part2 = numeros.slice(length - 4, length - 1);
      const part1 = numeros.slice(length - 7, length - 4);
      const part0 = numeros.slice(0, length - 7);
      nuevos = [...part0, '.', ...part1, '.', ...part2, '-', ...part3];
    } else if (length === 7) {
      const part3 = numeros.slice(length - 1);
      const part2 = numeros.slice(length - 4, length - 1);
      const part1 = numeros.slice(length - 7, length - 4);
      nuevos = [...part1, '.', ...part2, '-', ...part3];
    } else if (length === 6) {
      const part2 = numeros.slice(length - 3, length);
      const part1 = numeros.slice(length - 6, length - 3);
      nuevos = [...part1, '.', ...part2];
    }

    return nuevos.join('');
  } else {
    return numero;
  }
};

const Groups = props => {
  const { register, errors, handleSubmit, triggerValidation } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);

  const [numeroCedula, setNumeroCedula] = useState(state?.data?.numero_cedula || '');
  const [numeroCedulaMasked, setNumeroCedulaMasked] = useState(
    getMaskedNumber(state?.data?.numero_cedula) || '',
  );

  const [confirmaCedula, setConfirmaCedula] = useState(false);
  const [cedulaConfirmada, setCedulaConfirmada] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const onSubmit = data => {
    if (numeroCedula < 10_000_000 && !cedulaConfirmada) {
      action(data);
      setConfirmaCedula(true);
      return;
    }

    click_next_step2();

    action({
      ...data,
      numero_cedula: numeroCedula, // ??
      tipo_cedula: numeroCedula && parseInt(numeroCedula[0]) === 6 ? 'ci-nueva' : data.tipo_cedula,
      residencia: numeroCedula && parseInt(numeroCedula[0]) !== 6 ? 'Legal' : data.residencia,
    });
    props.history.push('/3');
  };

  const getNumeroCedula = numero => {
    setNumeroCedulaMasked(getMaskedNumber(numero));
    setNumeroCedula(numero);
  };

  const handleEditButton = () => {
    if (!isEditing) {
      setIsEditing(true);
    } else {
      setIsEditing(false);
    }
  };

  const confirmarCedula = () => {
    // console.log({numeroCedula});
    // action({ numero_cedula: numeroCedula });
    setConfirmaCedula(false);
    setCedulaConfirmada(true);
  };

  // const handleOutside = event => {
  //   if (editWrapperRef.current.contains(event.target)) {
  //     alert('click adentro');
  //   } else {
  //     alert('click outside');

  //   }
  // };

  useEffect(() => {
    if (isEditing) {
      const el = document.querySelector('.edit-wrapper input:not(#numero_cedula)');
      el.click();
      el.focus();
    }
  }, [isEditing]);

  useEffect(() => {
    if (isEditing && confirmaCedula) {
      document.addEventListener('keydown', e => {
        if (e.keyCode === 13) {
          setIsEditing(false);
        }
      });
    }
  }, [isEditing, confirmaCedula]);

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>Decinos tu número y tipo de documento.</Title>

        <Input
          type="tel"
          label="Número de documento"
          placeholder="1.234.567-8"
          mask={
            {
              // blocks: [1, 3, 3, 1],
              // delimiters: ['.', '.', '-'],
              // delimiterLazyShow: true,
              // numericOnly: true,
            }
          }
          id="numero_cedula"
          name="numero_cedula"
          watch={getNumeroCedula}
          defaultValue={state?.data?.numero_cedula}
          customMask={numeroCedulaMasked}
          register={register({
            required: 'Debe ingresar su número de Cédula de Identidad.',
            minLength: { value: 7, message: 'Debe tener al menos 7 números.' },
            maxLength: { value: 8, message: 'Debe tener hasta 8 números.' },
            validate: {
              format: value => (validate_ci(value) ? true : 'Cédula de Identidad inválida.'),
              noZeros: value =>
                value && value[0] != 0 ? true : 'La Cédula no puede empezar con cero.',
            },
          })}
          error={!confirmaCedula && errors.numero_cedula}
          triggerValidation={() => triggerValidation('numero_cedula')}
          focusOnMount={true}
          onKeyPress={event => {
            if (numeroCedulaMasked.length >= 11) {
              event.preventDefault();
              return false;
            }

            const regex = new RegExp('[0-9]+$');
            const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
              event.preventDefault();
              return false;
            }
          }}
        />

        {(numeroCedula == '' || (numeroCedula && parseInt(numeroCedula[0]) != 6)) && (
          <>
            <Label as="span" mb={10}>
              Tipo de documento
            </Label>

            <RadioGroup
              variant="image"
              name="tipo_cedula"
              options={cedulas}
              register={register({ required: 'Debe seleccionar el tipo de Cédula de Identidad.' })}
              error={errors.tipo_cedula}
              defaultChecked={state?.data?.tipo_cedula}
            />
          </>
        )}
        {numeroCedula && parseInt(numeroCedula[0]) == 6 && (
          <>
            <RadioGroup
              title="¿Qué tipo de residencia tenés?"
              name="residencia"
              options={residencias}
              register={register({ required: 'Debe seleccionar el tipo de residencia.' })}
              error={errors.residencia}
              defaultChecked={state?.data?.residencia}
            />
          </>
        )}
      </div>

      <Dialog
        isOpen={confirmaCedula}
        // onDismiss={() => setConfirmaCedula(false)}
        aria-label="Confirmación de cédula"
      >
        <ModalCedula
          onDismiss={() => setConfirmaCedula(false)}
          onEditFinish={() => setIsEditing(false)}
        >
          <div className="edit-wrapper">
            <div
              style={{ width: '100%', flex: 1 }}
              onClick={() => {
                !isEditing && setIsEditing(true);
              }}
            >
              <Input
                disabled={!isEditing}
                type="tel"
                label="Número de documento"
                placeholder="1.234.567-8"
                mask={
                  {
                    // blocks: [1, 3, 3, 1],
                    // delimiters: ['.', '.', '-'],
                    // delimiterLazyShow: true,
                    // numericOnly: true,
                  }
                }
                id="numero_cedula"
                name="numero_cedula"
                watch={getNumeroCedula}
                defaultValue={state?.data?.numero_cedula}
                customMask={numeroCedulaMasked}
                register={register({
                  required: 'Debe ingresar su número de Cédula de Identidad.',
                  minLength: { value: 7, message: 'Debe tener al menos 7 números.' },
                  maxLength: { value: 8, message: 'Debe tener hasta 8 números.' },
                  validate: {
                    format: value => (validate_ci(value) ? true : 'Cédula de Identidad inválida.'),
                    noZeros: value =>
                      value && value[0] != 0 ? true : 'La Cédula no puede empezar con cero.',
                  },
                })}
                error={errors.numero_cedula}
                triggerValidation={() => triggerValidation('numero_cedula')}
                focusOnMount={true}
                onKeyPress={event => {
                  if (numeroCedulaMasked.length >= 11) {
                    event.preventDefault();
                    return false;
                  }

                  const regex = new RegExp('[0-9]+$');
                  const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
                  if (!regex.test(key)) {
                    event.preventDefault();
                    return false;
                  }
                }}
              />
            </div>

            <button
              className={cn('edit-button', isEditing && 'active')}
              // onClick={() => setIsEditing(true)}
              onClick={handleEditButton}
            >
              {!isEditing ? (
                <svg width={21} height={20} fill="none">
                  <path
                    d="M20.008 3.477c0 .359-.07.64-.211.843a6.543 6.543 0 01-.258.399l-.82.797a3.466 3.466 0 00-.399-1.36c-.218-.453-.547-.898-.984-1.336l-.047-.047c0-.015-.008-.03-.023-.046-.016 0-.032-.008-.047-.024-.016-.015-.024-.031-.024-.047a5.748 5.748 0 00-1.336-.984 3.496 3.496 0 00-1.382-.399l.82-.796c.047-.063.172-.157.375-.282.219-.125.5-.187.844-.187.375 0 .75.101 1.125.304.39.188.78.477 1.172.868.39.39.687.78.89 1.172.203.375.305.75.305 1.125zm-3.445-.024c.39.39.68.781.867 1.172.203.375.304.75.304 1.125 0 .344-.07.625-.21.844a2.63 2.63 0 01-.258.375L6.648 17.586v.023h-.023l-.023.024-.024.023h-.023v.024H6.53c0 .015-.008.023-.023.023h-.024v.024h-.023v.023h-.047v.023h-.023-.024v.024h-.023l-4.946 2.11a.838.838 0 01-.21.07A.772.772 0 011 20H.906a1.295 1.295 0 01-.328-.094.742.742 0 01-.281-.21H.273c0-.016-.007-.024-.023-.024 0-.016-.008-.024-.023-.024v-.023l-.024-.023c0-.016-.008-.024-.023-.024v-.023l-.024-.024v-.023a.94.94 0 01-.14-.399 1.06 1.06 0 01.046-.445v-.023c.016-.016.024-.032.024-.047l2.11-4.946h.023v-.023-.023h.023v-.024-.023h.024v-.024l.023-.023v-.024c.016 0 .023-.007.023-.023l.024-.024.023-.023v-.023h.024v-.024h.023v-.023h.024L13.023 2.727c.063-.047.196-.133.399-.258.203-.14.484-.211.844-.211.375 0 .75.101 1.125.304.39.204.78.5 1.171.891zM5.242 14.75c-.36-.344-.673-.57-.938-.68-.266-.125-.485-.187-.657-.187-.171 0-.304.031-.398.094l-.117.07-.305.703L1 18.992l4.945-2.11.164-.515c.125-.36-.164-.898-.867-1.617zM15.858 4.156c-.359-.36-.671-.593-.937-.703-.266-.125-.485-.187-.656-.187-.188 0-.329.03-.422.093l-.117.094-9.516 9.492c.297.078.586.211.867.399.297.172.586.406.867.703.297.297.532.594.703.89.188.282.32.563.399.844l9.515-9.515.165-.516c.125-.36-.165-.89-.868-1.594z"
                    fill="currentColor"
                  />
                </svg>
              ) : (
                <svg
                  width="22"
                  height="15"
                  viewBox="0 0 22 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.8281 1.01562L8.70312 14.1172C8.51562 14.3203 8.28125 14.4219 8 14.4219C7.71875 14.4219 7.48438 14.3203 7.29688 14.1172L1.17969 8.02344C1.05469 7.89844 0.992188 7.75781 0.992188 7.60156C0.992188 7.42969 1.05469 7.28906 1.17969 7.17969C1.28906 7.05469 1.42188 6.99219 1.57812 6.99219C1.75 6.99219 1.89844 7.05469 2.02344 7.17969L8 13.1562L20.9844 0.171875C21.0938 0.0625 21.2344 0.0078125 21.4062 0.0078125C21.5781 0.0078125 21.7188 0.0625 21.8281 0.171875C21.9375 0.296875 21.9922 0.445312 21.9922 0.617188C21.9922 0.773438 21.9375 0.90625 21.8281 1.01562Z"
                    fill="currentColor"
                  />
                </svg>
              )}
            </button>
          </div>

          <Button
            id="confirma-cedula"
            style={{ width: '100%', display: 'block' }}
            disabled={isEditing}
            onClick={confirmarCedula}
          >
            Confirmar cédula
          </Button>
        </ModalCedula>
      </Dialog>

      <div className="form-actions">
        <Button block type="submit" id="next-button-step-2">
          Siguiente
        </Button>

        <BackButton />
      </div>

      <style jsx>{`
        .edit-wrapper :global(.input) {
          flex: 1;
          margin-bottom: 0;
        }
        .edit-wrapper {
          margin-bottom: 42px;
          margin-top: 20px;
          display: flex;
          align-items: flex-end;
        }

        .edit-button {
          cursor: pointer;
          height: 48px;
          width: 48px;
          margin-left: 16px;
          color: #007ab7;
          background: #fff;
          border: 1px solid #007ab7;
          border-radius: 4px;
        }

        .edit-button.active {
          color: white;
          background-color: #ff6200;
          border-color: #ff6200;
        }
      `}</style>
    </StackForm>
  );
};

export default withRouter(Groups);
